import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'superflex-pagar-btn',
    template: `
        <p-button
            label="{{'BOTONES.btnPagar' | translate}}"
            [icon]="icon"
            [styleClass]="styleClass"
            [class]="class"
            (onClick)="onClick.emit()"
            [disabled]="isDisabled">
        </p-button>`,
})
export class PagarBtnComponent {

    @Input() isDisabled: boolean;
    @Output() onClick = new EventEmitter<any>();
    @Input() icon = '';
    @Input() styleClass = 'p-button-primary p-mr-2';
    @Input() class = '';

    constructor() {/***/}
}
